<template>
  <div>
    <!-- 招贤纳士 -->
    <div class="recruit">
      <div class="title_box">
        <div class="en">RECRUITMENT</div>
        <div class="zh">招贤纳士</div>
        <div class="line"></div>
      </div>
      <div class="scollY_swiper_box">
        <swiper
          class="recruit_swiper_box"
          :options="swiperOption_recruit"
          ref="mySwiper"
        >
          <swiper-slide v-for="(item, index) in recruitData" :key="index">
            <div
              class="item_box"
              @mouseenter="itemEnter(index)"
              @mouseleave="itemLeave"
              @click="lookDetail(item)"
            >
              <div class="item_center">
                <div class="top_box">
                  <div class="post">
                    <img
                      src="../../assets/indexImg/recruit_color_user.png"
                      v-if="iconIndex === index"
                      alt=""
                    />
                    <img
                      src="../../assets/indexImg/recruit_user.png"
                      alt=""
                      v-else
                    />
                    <span>{{item.name}}</span>
                  </div>
                  <div class="look_more_box">
                    <span>查看详情</span
                    ><img
                      src="../../assets/indexImg/recruit_color_right.png"
                      v-if="iconIndex === index"
                      alt=""
                    /><img
                      src="../../assets/indexImg/recruit_right.png"
                      alt=""
                      v-else
                    />
                  </div>
                </div>
                <div class="line_"></div>
                <div class="bottom_box">
                  <div class="bottom_texts">学历：{{item.education}}</div>
                  <div class="bottom_texts">招聘人数：{{item.number}}人</div>
                  <div class="bottom_texts">专业：{{item.major}}</div>
                  <div class="bottom_texts">工作地点：{{item.address}}</div>
                  <div class="bottom_texts">发布时间：{{item.create_time}}</div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="detail_pre_view_box" v-if="detailsFlag">
        <div class="detail_center_box">
          <img
            @click="colse"
            class="img_cover colse_img"
            src="../../assets/indexImg/cancel.png"
            alt=""
          />
          <div class="top_box">
            <div class="item_box" v-for="(item, index) in arr" :key="index">
              <div class="title">{{ item.title }}</div>
              <div class="content">{{ item.content }}</div>
            </div>
          </div>
          <div class="content_box">
            <div class="duty_box">
              <div class="title_duty">【岗位职责】</div>
              <div class="info_box">
               {{detail.duty}}
              </div>
            </div>
            <div class="qualifications">
              <div class="title_qualifications">【任职资格】</div>
              <div class="info_box">
               {{detail.qualifications}}
              </div>
            </div>
            <div class="email_box">应聘邮件发送至:{{email}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getRecruitList,getRecruitInfo,getConfig} from '../../http/api'
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      arr: [
        {
          title: "岗位名称",
          content: "融资经理/主管",
        },
        {
          title: "所属部门",
          content: "财务部门",
        },
        {
          title: "学历要求",
          content: "本科",
        },
        {
          title: "工作地点",
          content: "成都",
        },
        {
          title: "薪资",
          content: "面议",
        },
      ],
      swiperOption_recruit: {
        slidesPerView: 3,
        direction: "vertical",
        mousewheel: true,
        sensitivity: 0.1,
      },
      iconIndex: -1,
      detailsFlag: false,
      recruitData:[],
      detail:{},
    };
  },
  methods: {
    itemLeave() {
      this.iconIndex = -1;
    },
    itemEnter(i) {
      this.iconIndex = i;
    },
    lookDetail(item) {
      this.detailsFlag = true;
      this.getdetail(item.id)  
    },
    colse() {
      this.detailsFlag = !this.detailsFlag;
    },
    getdata(){
      getRecruitList().then(res=>{
          this.recruitData = res.data
      })
    },
    getdetail(id){
      getRecruitInfo({id:id}).then(res=>{
          this.detail = res.data
          this.arr.map((item,index)=>{
            switch (index) {
                case 0:
                  item.content = res.data.name;
                  break;
                case 1:
                  item.content = res.data.mechanism;
                  break;
                case 2:
                  item.content = res.data.education;
                  break;
                case 3:
                  item.content = res.data.address;
                  break;
                case 4:
                  item.content = res.data.salary;
                  break;
              }
          })
      })
    },
  },
  mounted() {
     getConfig().then((res) => {
       this.email = res.data.recruit_email
    });
    this.getdata()
    
  },
};
</script>

<style scoped lang='scss'>
.recruit {
  width: 1200px;
  // height: 678px;
  height: 67.8vh;
  margin: 0 auto;
  // margin-top: 40px;
  margin-top: 4vh;
  .title_box {
    width: 506px;
    // height: 90px;
    height: 9vh;
    position: relative;
    margin: 0 auto;
    .en {
      width: 100%;
      height: 100%;
      font-size: 68px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      // line-height: 90px;
      line-height: 9vh;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      width: 100%;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      position: absolute;
      // bottom: 10px;
      bottom: 1vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .scollY_swiper_box {
    width: 1200px;
    // height: 548px;
    height: 54.8vh;
    // margin-top: 40px;
    margin-top: 4vh;
    .recruit_swiper_box {
      width: 100%;
      height: 100%;
      .item_box {
        width: 1198px;
        // height: 154px;
        height: 15.4vh;
        border: 1px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.5s;
        box-shadow: 0px 2px 4px rgba(26, 26, 26, 0.2);
        color: #ffffff;
        .item_center {
          width: 1120px;
          // height: 98px;
          height: 9.8vh;
          .top_box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            // margin-bottom: 27px;
            margin-bottom: 2.7vh;
            .post {
              font-size: 22px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              // line-height: 29px;
              line-height: 2.9vh;
              img {
                margin-right: 20px;
              }
            }
            .look_more_box {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              // line-height: 29px;
              line-height: 2.9vh;
              img {
                margin-left: 10px;
              }
            }
          }
          .line_ {
            width: 1120px;
            height: 1px;
            background: #fff;
          }
          .bottom_box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            // margin-top: 27px;
            margin-top: 2.7vh;
            .bottom_texts {
              height: 19px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              // line-height: 19px;
              line-height: 1.9vh;
            }
          }
        }
      }
      .item_box:hover {
        transition: all 0.5s;
        color: #0fffff;
        border: 1px solid #0fffff;
        .line_ {
          background: #0fffff;
        }
      }
    }
  }
  .detail_pre_view_box {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(26, 26, 26, 0.8);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    .detail_center_box {
      width: 1400px;
      // height: 696px;
      height: 69.6vh;
      background: #ffffff;
      position: relative;
      .colse_img {
        width: 24px;
        height: 24px;
        position: absolute;
        // top: 40px;
        top: 4vh;
        right: 40px;
      }
      .top_box {
        width: 1200px;
        margin: 0 auto;
        // margin-top: 100px;
        margin-top: 10vh;
        // height: 79px;
        height: 7.9vh;
        border-bottom: 1px solid #c8c8c8;
        display: flex;
        justify-content: space-between;
        .item_box {
          width: 240px;
          height: 100%;
          display: flex;
          flex-direction: column;
          position: relative;
          .title {
            width: 100%;
            text-align: center;
            color: #909090;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }
          .content {
            width: 100%;
            text-align: center;
            font-size: 22px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1a1a1a;
            // margin-top: 10px;
            margin-top: 1vh;
          }
        }
        .item_box:first-child::before {
          display: none;
        }
        .item_box::before {
          content: "|";
          display: inline-block;
          position: absolute;
          top: 17px;
          color: #c8c8c8;
        }
      }
      .content_box {
        width: 1200px;
        margin: 0 auto;
        // margin-top: 40px;
        margin-top: 4vh;
        .duty_box {
          width: 100%;
          // margin-bottom: 40px;
          margin-bottom: 4vh;
          .title_duty {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 24px;
            line-height: 2.4vh;
            color: #1a1a1a;
            // margin-bottom: 10px;
            margin-bottom: 1vh;
          }
          .info_box {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 19px;
            line-height: 1.9vh;
            color: #4d4d4d;
            white-space: pre-wrap;
          }
        }
        .qualifications {
          width: 100%;
          .title_qualifications {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 24px;
            line-height: 2.4vh;
            color: #1a1a1a;
            // margin-bottom: 10px;
            margin-bottom: 1vh;
          }
          .info_box {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            // line-height: 19px;
            line-height: 1.9vh;
            color: #4d4d4d;
            white-space: pre-wrap;
          }
        }
        .email_box {
          width: 280px;
          // height: 40px;
          height: 4vh;
          background: rgba(26, 26, 26, 0.6);
          // margin-top: 40px;
          margin-top: 4vh;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          // line-height: 40px;
          line-height: 4vh;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
</style>